module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLightIt.4afb8c08.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLightIt.woff
// module id = 321
// module chunks = 3